import React, { memo } from 'react';
import ReviewContainer from 'containers/ReviewsContainer';

import {
  questReviewsListUrl,
  quizListUrl,
} from 'utils/api/requestUrls';

const ReviewsPage = (props: any) => {
  return (
    <ReviewContainer {...props} />
  );
};

export const getServerSideProps = async (context) => {
  const { req, res } = context;
  const quizId = context.query.quizId;

  const reviewListesponse = await fetch(questReviewsListUrl(quizId));
  const reviewListJSON = await reviewListesponse?.json();
  
  const questListResponse = await fetch(quizListUrl(null, null));
  const questListFirstData = await questListResponse.json();

  if (req.headers.host.match(/^www/) !== null) {
    res.writeHead(301, {
      location: "https://" + req.headers.host.replace(/^www./, "") + req.url,
    });
    res.end();
  };

  return {
    props: {
      reviewListJSON: reviewListJSON?.content,
      questListFirstData: questListFirstData?.content,
    }
  };
};

export default memo(ReviewsPage);


